module.exports = __webpack_public_path__ + "static/media/stamp_mask_v.3d90f82b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stamp_mask_v.svg
// module id = 601
// module chunks = 0